<template>
  <div v-if="!loader">
    <v-row class="justify-space-between align-center">
      <v-col lg="10">
        <v-btn
          @click="createDialog = true"
          x-large
          class="ma-6 pa-2 rounded-xl"
          color="primary"
        >
          {{ $t("add new edu class") }}<v-icon class="ma-2">mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col class="d-flex justify-end " lg="2">
        <v-row class="justify-end">
          <v-icon
            @click="layout = 'table'"
            :color="layout == 'table' ? 'primary' : 'grey'"
            class="mx-1"
            size="40"
            >mdi-view-list</v-icon
          >
          <v-divider vertical />
          <v-icon
            @click="layout = 'card'"
            :color="layout == 'card' ? 'primary' : 'grey'"
            class="mx-1"
            size="40"
            >mdi-cards</v-icon
          >
        </v-row>
      </v-col>
    </v-row>
    <create
      @createData="create"
      @closePopup="createDialog = false"
      :dialog="createDialog"
      :loader="craeteLoader"
    />
    <edit
      @editData="edit"
      @closePopup="editDialog = false"
      :dialog="editDialog"
      :orginalData="editData"
      :loader="editLoader"
    />
    <delete-popup
      @deleteData="deleteItem($event)"
      @closePopup="deleteDialog = false"
      :dialog="deleteDialog"
      :loader="deleteLoader"
      :item="deleteData"
    />
    <v-row v-if="layout == 'card'">
      <v-col
        v-for="(item, i) in subjects"
        :key="i"
        lg="6"
        md="6"
        sm="12"
        cols="12"
      >
        <card
          @clicked="$emit('openEduClass', $event)"
          :icon="'mdi-alpha-a-circle'"
          :item="item"
          :editAble="editAble"
          :deleteAble="deleteAble"
        />
      </v-col>
    </v-row>
    <v-row v-if="layout == 'table'">
      <v-col lg="12">
        <data-table
          :headers="headers"
          :data="subjects"
          :editable="editAble"
          :deleteable="deleteAble"
          :loader="false"
          :meta="{}"
          :showable="
            (item) => {
              $emit('openEduClass', item);
            }
          "
        />
      </v-col>
    </v-row>
  </div>
  <pulse-loader
    v-else
    :loading="true"
    size="20px"
    :color="$vuetify.theme.themes.light.primary"
  />
</template>
<script>
import { eduClass } from "@/store/common/eductionalClass";
import card from "../card.vue";
import create from "@/pages/Dashboard/schools/semesters & managers/semesters/create.vue";
import edit from "@/pages/Dashboard/schools/semesters & managers/semesters/edit.vue";
export default {
  props: ["id", "enableEdit"],
  components: {
    create,
    edit,
    card,
  },
  data() {
    return {
      eduClass,
      params_id: "grade_id",
      createDialog: false,
      editDialog: false,
      editData: null,
      deleteDialog: false,
      deleteData: null,
      layout: "card",
      headers: {
        id: {
          name: "id",
          keys: ["id"],
        },
        name: {
          name: "name",
          keys: ["name"],
        },
      },
    };
  },
  methods: {
    getData() {
      let params = {
        grade_id: this.id,
      };
      this.name.get(params);
    },
    //create
    async create(data) {
      let payload = {
        name: data.name,
        grade_id: this.id,
      };
      await this.name.post(payload);
      this.createDialog = false;
      this.getData();
    },

    //edit
    editAble(data) {
      this.editData = data;
      this.editDialog = true;
    },
    async edit(data) {
      await this.name.edit(data.data, data.id);
      this.editDialog = false;
      this.getData();
    },

    //delete
    deleteAble(data) {
      this.deleteData = data;
      this.deleteDialog = true;
    },
    async deleteItem(id) {
      await this.name.deleteItem(id);
      this.deleteDialog = false;
      this.getData();
    },
  },
  computed: {
    name() {
      return eduClass;
    },
    subjects() {
      return this.name.tableData.data;
    },

    //loaders
    loader() {
      return this.name.getState.loading;
    },
    craeteLoader() {
      return this.name.postState.loading;
    },
    editLoader() {
      return this.name.editState.loading;
    },
    deleteLoader() {
      return this.name.deleteState.loading;
    },
  },
  created() {
    this.getData();
  },
};
</script>
